<script setup lang="ts">
defineProps({
  variant: {
    type: String, // variants: warning, info, announcement
    default: 'info',
  },
  message: {
    type: String,
    required: true,
  },
  link: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['dismiss'])
function handleDismiss() {
  emit('dismiss')
}
</script>

<template>
  <div
    class="w-full py-6"
    :class="{ 'bg-med-orange dark-bg': variant === 'warning', 'bg-med-aqua': variant === 'info', 'bg-med-light-gray': variant === 'announcement' }"
  >
    <div class="container-fluid flex items-start justify-between gap-4">
      <div
        class="alert__body prose"
        :class="{ 'dark-bg': variant === 'warning' }"
      >
        <span v-html="message" />
        <NuxtLink
          v-if="link"
          :to="useCmsUrl(link.url)"
          class="ml-2"
        >
          {{ link.text }}
        </NuxtLink>
      </div>
      <button
        class="close-btn"
        @click="handleDismiss"
      >
        <svg
          aria-hidden="true"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L21 21"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            d="M21 1L1 21"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
        <span class="close-btn__label">close</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.alert__body {
  max-width: 100%;
  > * {
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.close-btn {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}
.close-btn__label {
  position: absolute;
  white-space: nowrap;
  top: 100%;
  left: 100%;
}
</style>
